export const backoffBaseOptions = {min: 100, max: 30_000, jitter: 0.2};
export const NONE = 'none';
